/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

export const getApiPath = (): string => {
	return `${process.env.NEXT_PUBLIC_EPIC_SERVER_URL || ""}${process.env.NEXT_PUBLIC_COSMOS_API_PATH || "/api"}`;
};
